import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get, put, remove } from '../../api';
import { InvitedUser, SelectType, UserData } from '../../components/common/types';
import Team from '../../components/team';
import TeamTable from '../../components/team/table';
import { getPermissions } from '../user/userSlice';

export default function TeamContainer () {

  const [data, setData] = useState<Array<UserData>>([]);
  const [invitedUsers, setInvitedUsers] = useState<Array<InvitedUser>>([]);
  const [roles, setRoles] = useState<Array<SelectType>>([]);
  const [locations, setLocations] = useState<Array<SelectType>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState('');
  const permissions = useSelector(getPermissions);

  const loadUsers = async() => {

    setLoading(true);
    const response = await get('users').catch(console.error);
    
    setLoading(false);
    if (response.status === 200) {
  
      setData(response.data.users);
      setInvitedUsers(response.data.invites);
      setLocations(response.data.options.locations);
      setRoles(response.data.options.roles);
    } else {
      setError('Failed to load users data');
    }
  };

  const removeInvitedHandler = async(id: number) => {
    
    setLoading(true);
    const response = await remove('invite/' + id, {}).catch(console.error);
    setLoading(false);

    if (!response) {
      setError('Failed to delete user invite');
      return;
    }

    if (response?.status === 200) {
      setError('');
      loadUsers();
    } else {
      setError('Failed to delete user invite');
    }
  };

  const locationSelectHandler = async (userData: UserData, data: SelectType[]) => {

    setLoading(true);
    const response = await put('users/'+userData.id+'/locations', { locations: data.map(x=>x.id) }).catch(console.error);
    setLoading(false);

    if (response?.status === 200) {
      setError('');
      loadUsers();
    } else {
      setError('Failed to set location');
      
      loadUsers();
    }
  };

  const roleSelectHandler = async (userData: UserData, data: SelectType[]) => {

    setLoading(true);
    const response = await put('users/'+userData.id+'/roles', { roles: data.map(x=>x.id) }).catch(console.error);
    
    setLoading(false);
    if (response.status === 200) {
      setError('');
      loadUsers();
    } else {
      setError(response?.data?.message ?? 'Failed to set role');
      loadUsers();
    }
  };

  const inviteCloseHandler = async () => {

    loadUsers();
  };

  const deleteMemberHandler = async (data: UserData) => {
    
    setLoading(true);
    const response = await remove('users/' + data.id).catch(console.error);
    
    if (!response) {
      setError('Failed to delete user');
      return;
    }

    setLoading(false);
    if (response?.status === 200) {
      setError('');
      loadUsers();
    } else {
      setError(response?.data?.message ?? 'Failed to delete');
      loadUsers();
    }

    return;
  };

  useEffect(()=>{
    loadUsers();
  }, []);

  return <Team 
    error={error}
    data={data} 
    onInviteClose={inviteCloseHandler}
    locations={locations} 
    roles={roles} 
    loading={loading}
    invitedUsers={invitedUsers}
    removeInvitedUser={removeInvitedHandler}
    onSelectLocation={locationSelectHandler}
    onSelectRole={roleSelectHandler}
    onDeleteMember={deleteMemberHandler}
    showLocations={permissions.includes('MANAGE_TEAM_LOCATIONS')}
  />;
}